import React from 'react';
import { createRoot } from 'react-dom/client';
import Hub from './components/hub.jsx';
import FleetBlock from './components/FleetBlock.jsx';
import LiveBoard from './components/LiveBoard.jsx';
//import ChatWidget from './components/chat/ChatWidget.jsx';

function initReact() {
  console.log('🔍 initReact вызван!');

  // ===== HUB =====
  const container = document.getElementById('react-hubs-block');
  if (container) {
    const root = createRoot(container);
    root.render(<Hub />);
  }

  // ===== FLEET =====
  const fleetContainer = document.getElementById('react-fleet-block');
  if (fleetContainer) {
    const root = createRoot(fleetContainer);
    root.render(<FleetBlock />);
  }

  // ===== LIVEBOARD =====
  const liveboardContainer = document.getElementById('react-liveboard');
  if (liveboardContainer) {
    const root = createRoot(liveboardContainer);
    root.render(<LiveBoard />);
  }

  console.log('🔍 Инициализация Пульк...');

  // ===== ЧАТ =====
  const chatContainer = document.createElement('div');
  chatContainer.id = 'chat-widget-root';
  document.body.appendChild(chatContainer);

  let chatRoot = null;
  let isChatOpen = false;

  // ===== ОБНОВЛЕНИЕ БАДЖА =====
  window.updateChatBadge = (count) => {
    const badge = document.getElementById('plkChatBadge');
    const sideBadge = document.getElementById('plkSideBadge');
    
    const displayCount = parseInt(count) || 0;
    
    console.log('🔔 updateChatBadge:', { count, displayCount });
    
    if (badge) {
      if (displayCount > 0) {
        badge.textContent = displayCount > 99 ? '99+' : displayCount;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
        badge.textContent = '';
      }
    }
    
    if (sideBadge) {
      if (displayCount > 0) {
        sideBadge.textContent = displayCount > 99 ? '99+' : displayCount;
        sideBadge.style.display = 'inline-flex';
      } else {
        sideBadge.style.display = 'none';
        sideBadge.textContent = '';
      }
    }
  };

  // ===== ОТКРЫТИЕ/ЗАКРЫТИЕ ЧАТА =====
  window.toggleChat = (userId) => {
    console.log('🔍 toggleChat вызван, userId:', userId);
    
    if (!userId) {
      window.location.href = '/login';
      return;
    }

    const container = document.getElementById('chat-widget-root');
    if (!container) {
      console.error('❌ Контейнер чата не найден!');
      return;
    }

    if (isChatOpen) {
      if (chatRoot) {
        chatRoot.unmount();
        chatRoot = null;
      }
      isChatOpen = false;
      document.body.classList.remove('chat-open');
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
      console.log('✅ Чат закрыт');
      return;
    }

    console.log('🔍 Открываем чат для пользователя:', userId);

    if (!chatRoot) {
      chatRoot = createRoot(container);
    }

    try {
      chatRoot.render(
        React.createElement(ChatWidget, {
          userId: userId,
          onClose: () => {
            if (chatRoot) {
              chatRoot.unmount();
              chatRoot = null;
            }
            isChatOpen = false;
            document.body.classList.remove('chat-open');
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.height = '';
          },
          onUnreadUpdate: window.updateChatBadge
        })
      );
      isChatOpen = true;
      document.body.classList.add('chat-open');
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      console.log('✅ Чат открыт!');
    } catch (error) {
      console.error('❌ Ошибка рендеринга чата:', error);
    }
  };

  // ===== ГЛОБАЛЬНЫЙ ОБЪЕКТ =====
  window.PulkChat = {
    socket: null,
    setSocket: (socket) => {
      window.PulkChat.socket = socket;
      console.log('🔌 Сокет сохранён в window.PulkChat');
    },
    getSocket: () => window.PulkChat.socket,
    toggle: window.toggleChat,
    updateBadge: window.updateChatBadge
  };

  // ===== ПОЛУЧЕНИЕ НЕПРОЧИТАННЫХ =====
  const user = window.__INITIAL_USER__ || null;
  if (user && user.plk_id) {
    fetch('/api/unread')
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          const count = parseInt(data.data.count) || 0;
          console.log('📊 Начальный счётчик непрочитанных:', count);
          window.updateChatBadge(count);
        }
      })
      .catch((err) => console.error('❌ Ошибка загрузки непрочитанных:', err));
  }

  console.log('✅ Пульк: инициализирован!');
  console.log('✅ window.PulkChat:', window.PulkChat);
}

// ===== ЗАПУСК =====
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReact);
} else {
  initReact();
}

// ===== ЗАПАСНОЙ ЗАПУСК =====
setTimeout(() => {
  if (typeof window.PulkChat === 'undefined') {
    console.log('🔄 Запасной запуск Пульк...');
    initReact();
  }
}, 200);